import { useState } from 'react'

const FAQS = [
    {
        question: 'Which audiences and triggers do you support?',
        answer: 'New mover, new patient prospecting in your service area, family households, lapsed patient reactivation, recall reminders, and outstanding invoice nudges. We can also work from a list you bring, including your practice management system exports.',
    },
    {
        question: 'How fast does mail actually drop?',
        answer: "We trigger mail to drop within 2 business days of the audience being approved. For time-sensitive moments like new movers and recall windows, that's usually the difference between landing while the patient is choosing a dentist or after they've already booked elsewhere.",
    },
    {
        question: 'Can you run a recurring weekly cadence?',
        answer: 'Yes. Most dental practices run weekly or biweekly drops across new patient acquisition, recall, reactivation, and family campaigns, with multiple touches per record. We handle data, creative, mail production, and tracking on a recurring cadence.',
    },
    {
        question: "What's the minimum spend to get started?",
        answer: "There's no fixed minimum, but this is built for recurring campaigns rather than one-off print orders. Most dental practices run programs in the $3,500 to $15,000 monthly range depending on locations, service area size, and growth goals. If you only need the cheapest postcard order, we're probably not the right fit.",
    },
]

function PlusIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    )
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null)

    return (
        <section className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 lg:py-16">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        Frequently asked
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3F454F] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Questions dental practices ask first.
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    {FAQS.map((faq, i) => (
                        <div
                            key={i}
                            className="flex flex-col rounded-2xl border border-secondary/30 bg-white">
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenIndex(openIndex === i ? null : i)
                                }
                                className="flex w-full cursor-pointer flex-row items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left transition-colors hover:bg-secondary/[0.03]">
                                <span
                                    className="text-lg font-semibold text-[#3F454F]"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.question}
                                </span>
                                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10">
                                    <PlusIcon
                                        className={`h-4 w-4 text-secondary transition-transform duration-200 ${
                                            openIndex === i ? 'rotate-45' : ''
                                        }`}
                                    />
                                </div>
                            </button>
                            <div
                                className="overflow-hidden transition-all duration-300"
                                style={{
                                    maxHeight: openIndex === i ? '500px' : '0',
                                    opacity: openIndex === i ? 1 : 0,
                                }}>
                                <div
                                    className="px-6 pb-6 text-lg text-[#3F454F]/70"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
